import get from 'lodash/get';
import { compose, graphql } from 'react-apollo';
import { parseJsonFields } from '../../../services/parseApiService';
import { GetJob } from '../../graphql/custom/jobs';

export const withGetJobById = (Component, variables) => {
	return compose(
		graphql(GetJob, {
			options(props) {
				return {
					context: {
						headers: {
							'x-frame-options': 'deny', // This header will reach the server
						},
					},
					variables: { id: get(props, 'jobId', 'skip') },
					fetchPolicy: 'network-only',
				};
			},
			props(response, props) {
				let originalJob = get(props, 'data.getJob', undefined);
				let currentJob = undefined;
				if (originalJob) {
					const parsedFields = parseJsonFields(['location', 'salary', 'referralBonus'], originalJob);
					currentJob = { ...originalJob, ...parsedFields };
				}
				return {
					currentJob,
				}
			},
		})
	)(Component);
};
